import { render, staticRenderFns } from "./CategoryContactsPage.vue?vue&type=template&id=0b2ca6a8&scoped=true&"
import script from "./CategoryContactsPage.vue?vue&type=script&lang=js&"
export * from "./CategoryContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ca6a8",
  null
  
)

export default component.exports